module.exports = __webpack_public_path__ + "img/category-title04-m.84519e66.png";